import React from 'react';
import { webAssetUrl } from 'lib/utils/imageUtils';

interface Props {
  className?: string;
}

export const DesktopLogo = ({
  className,
}: Props) => (
  <img src={webAssetUrl('color-logo.png')} alt="Gondola Logo" className={className} />
);
